var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"bigTitle"},[_vm._v("负荷实时分析")]),_c('vchart',{ref:"vchart",staticStyle:{"height":"calc(100% - 68px)","margin-top":"19px"},attrs:{"themes":"UbiquitousOverviewChartSkin"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }